export const AGREEMENT_SUB_TYPE = {
  /** 닥터나우 서비스 이용 약관 */
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  /** 개인정보처리 위탁 계약 */
  CONSIGNMENT_CONTRACT: 'CONSIGNMENT_CONTRACT'
} as const;

export type AgreementSubType =
  typeof AGREEMENT_SUB_TYPE[keyof typeof AGREEMENT_SUB_TYPE];

export interface AgreementDto {
  id: number;
  agreementType: string;
  title: string;
  url: null | string;
  isRequired: boolean;
  agreementSubType: AgreementSubType;
}

export interface Agreement extends AgreementDto {
  isChecked?: boolean;
  image?: string;
  subtitle?: string;
}

export interface AgreementCheckParams {
  agreementType: string;
}

export interface updateAgreementCheckRequestParam {
  agreementType: string;
  approvedAgreementIds: number[];
  disapprovedAgreementIds: number[];
}
